import {makeAutoObservable} from "mobx";

export class StorySection {
    id: string;
    text: string;
    image: string | undefined;
    userText: string | undefined;
    endOfStory: boolean;
    images: any[];
    picture: string;  // a drawn picture's state: pending, ready, failed (the reader can try again) or none; empty for a bank picture

    constructor(id: string, text: string, image: string | undefined, images: any[] = [], endOfStory: boolean, userText: string | undefined = undefined, picture: string = '') {
        this.id = id;
        this.text = text;
        this.image = image
        this.images = images;
        this.endOfStory = endOfStory
        this.userText = userText
        this.picture = picture || ''
        makeAutoObservable(this)
    }

    setId(id: string) {
        this.id = id;
    }

    setPicture(picture: string, image: string | undefined) {
        this.picture = picture || '';
        this.image = image || undefined;
    }

    updateText(text: string) {
        this.text = text;
    }

    updateImage(image: string) {
        this.image = image;
    }

    setImages(images: any[]) {
        this.images = images;
        this.image = images[0].src;
    }

    toJSON() {
        return {
            id: this.id,
            text: this.text,
            image: this.image,
            images: this.images,
            endOfStory: this.endOfStory,
            picture: this.picture,
        };
    }

    static fromJson(json: any): StorySection {
        const {id, text, image, images, endOfStory, picture} = json;
        return new StorySection(id, text, image, images, endOfStory, undefined, picture);
    }


}